import React, { useEffect, useState } from "react";
import { minhasSimulacoes, criarSimulacao, cancelarSimulacao, remarcarSimulacao } from "../services/api";
import { abrirSala } from "../services/abrirSala";

// 🧪 SIMULAR UMA ENTREVISTA (piloto, 23/10/2026): a empresa testa a sala de entrevista com um COLEGA antes de usar
// com candidato de verdade. O colega entra sem conta, pelo link que vai no e-mail; o recrutador entra logado.
// Não conta em reputação, indicadores nem retorno de candidatura (tabela própria no servidor).
// Piloto: só e-mail (23/10/2026). Volta a true quando o colega puder ativar o WhatsApp ele mesmo.
const MOSTRAR_WHATSAPP = false;
const quando = (iso) => new Date(iso).toLocaleString("pt-BR", { weekday: "short", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
const STATUS = {
  agendada: { txt: "Agendada", cls: "bg-blue-100 text-blue-800" },
  realizada: { txt: "Realizada", cls: "bg-green-100 text-green-800" },
  nao_realizada: { txt: "Não aconteceu", cls: "bg-slate-100 text-slate-700" },
  cancelada: { txt: "Cancelada", cls: "bg-red-100 text-red-700" },
};
const FEEDBACK = { nenhum: "não pedido", pedido: "pedido", gerado: "gerado", enviado: "enviado ✓" };

// 23/10/2026 (2ª etapa): o mesmo modal cria e REMARCA (remarcar = só horário/duração e, se quiser, o WhatsApp do colega).
const paraCampoLocal = (iso) => new Date(new Date(iso).getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16);
function ModalSimulacao({ fechar, criada, limite = 3, remarcar = null }) {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [agora, setAgora] = useState(!remarcar);
  const [data, setData] = useState(remarcar ? paraCampoLocal(remarcar.inicio) : "");
  const [duracao, setDuracao] = useState(remarcar?.duracaoMin || 30);
  const [whats, setWhats] = useState("");
  const [aceiteWhats, setAceiteWhats] = useState(false);
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  const minimo = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 16);
  const temWhats = whats.replace(/\D/g, "").length > 0;
  const pronto = (remarcar || (nome.trim().length >= 2 && /\S+@\S+\.\S+/.test(email.trim()))) && (agora || data) && (!temWhats || aceiteWhats);
  const enviar = async () => {
    setErro(""); setEnviando(true);
    const horario = { agora, inicio: agora ? null : new Date(data).toISOString(), duracaoMin: duracao,
      whatsappColega: temWhats ? whats.trim() : null, consentimentoWhatsapp: temWhats && aceiteWhats };
    try {
      const r = remarcar ? await remarcarSimulacao(remarcar.id, horario)
        : await criarSimulacao({ nomeColega: nome.trim(), emailColega: email.trim(), ...horario });
      criada(r);
    } catch (e) { setErro(e.message); } finally { setEnviando(false); }
  };
  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" onClick={fechar}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-5 max-h-[94vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-bold text-gray-900">{remarcar ? `🧪 Remarcar a simulação com ${remarcar.nomeColega}` : "🧪 Simular uma entrevista"}</h2>
        {remarcar && <p className="text-sm text-gray-600 mt-1">O colega recebe por e-mail o convite ATUALIZADO (o evento da agenda dele muda de horário). Remarcar não conta no limite da semana.</p>}
        <div className={(remarcar ? "hidden " : "") + "mt-2 rounded-xl bg-amber-50 border border-amber-200 p-3 text-sm text-amber-900 space-y-1"}>
          <p><b>É um piloto.</b> Chame um colega da sua equipe para fazer o papel de candidato e conheça a sala de entrevista do eaiRH antes de usar com candidatos de verdade.</p>
          <p>• <b>Não conta na reputação</b> da empresa nem em nenhum indicador.</p>
          <p>• <b>Ninguém real é exposto</b>: não há vaga nem candidato envolvido.</p>
          <p>• <b>Feedback da IA é opcional</b>: na sala, cada um escolhe se quer receber o seu. Por ser piloto, a equipe do eaiRH pode ler esse feedback para melhorar a ferramenta.</p>
        </div>
        <div className="space-y-3 mt-4 text-sm">
          {!remarcar && <>
          <label className="block">
            <span className="text-gray-600">Nome do colega</span>
            <input value={nome} onChange={(e) => setNome(e.target.value)} maxLength={80} placeholder="Ex.: Ana Souza"
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2" />
          </label>
          <label className="block">
            <span className="text-gray-600">E-mail do colega (recebe o link da sala, sem precisar de conta)</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={200} placeholder="ana@suaempresa.com.br"
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2" />
          </label>
          </>}
          <div>
            <span className="text-gray-600">Quando</span>
            <div className="flex flex-wrap gap-4 mt-1">
              <label className="flex items-center gap-1.5"><input type="radio" checked={agora} onChange={() => setAgora(true)} /> Agora</label>
              <label className="flex items-center gap-1.5"><input type="radio" checked={!agora} onChange={() => setAgora(false)} /> Escolher data e hora</label>
            </div>
            {!agora && <input type="datetime-local" min={minimo} value={data} onChange={(e) => setData(e.target.value)}
              className="mt-2 w-full rounded-lg border border-gray-300 px-3 py-2" />}
          </div>
          <label className="block">
            <span className="text-gray-600">Duração</span>
            <select value={duracao} onChange={(e) => setDuracao(Number(e.target.value))} className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2">
              {[20, 30, 45, 60].map((m) => <option key={m} value={m}>{m} min</option>)}
            </select>
          </label>
          {/* WhatsApp opcional: só com o aceite explícito de que o colega concorda em receber (LGPD).
              23/10/2026 (Nelson): ESCONDIDO no piloto — só e-mail. O aceite tem de ser do PRÓPRIO colega (link no
              e-mail do convite), não do recrutador por ele; até isso existir, o campo fica fora da tela. */}
          {MOSTRAR_WHATSAPP && <>
          <label className="block">
            <span className="text-gray-600">WhatsApp do colega (opcional{remarcar?.whatsappColega ? `; hoje: ${remarcar.whatsappColega} — em branco mantém` : ""})</span>
            <input type="tel" value={whats} onChange={(e) => setWhats(e.target.value)} maxLength={20} placeholder="(11) 91234-5678"
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2" />
          </label>
          {temWhats && (
            <label className="flex items-start gap-2 text-xs text-gray-700">
              <input type="checkbox" className="mt-0.5" checked={aceiteWhats} onChange={(e) => setAceiteWhats(e.target.checked)} />
              <span>Confirmo que o colega concorda em receber mensagens do eaiRH pelo WhatsApp sobre esta simulação (confirmação, remarcação e lembrete de 1 hora antes).</span>
            </label>
          )}
          </>}
          <p className="text-xs text-gray-500">A sala abre 15 minutos antes e fecha 10 minutos depois do horário previsto. Lembretes por e-mail: na véspera e 1 hora antes, quando houver antecedência. Limite do piloto: {limite} simulações por empresa a cada 7 dias (remarcar não conta).</p>
        </div>
        {erro && <p className="mt-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={fechar} className="rounded-lg px-4 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-100">Cancelar</button>
          <button onClick={enviar} disabled={!pronto || enviando}
            className="rounded-lg bg-accent hover:opacity-90 disabled:opacity-40 text-white text-sm font-semibold px-4 py-2">{enviando ? (remarcar ? "Remarcando…" : "Criando…") : (remarcar ? "Remarcar e avisar o colega" : "Criar e enviar convite")}</button>
        </div>
      </div>
    </div>
  );
}

export default function SimularEntrevista() {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState("");
  const [modal, setModal] = useState(false);
  const [remarcando, setRemarcando] = useState(null);   // simulação aberta no modal de remarcar
  const carregar = () => minhasSimulacoes().then(setDados).catch((e) => setErro(e.message));
  useEffect(() => { carregar(); }, []);
  const copiar = (t) => { if (navigator.clipboard) navigator.clipboard.writeText(t).then(() => setAviso("Link do colega copiado.")).catch(() => {}); };
  const esgotou = dados && dados.usadas >= dados.limite;
  return (
    <div className="mt-5">
      {modal && <ModalSimulacao limite={dados?.limite} fechar={() => setModal(false)} criada={(r) => {
        setModal(false); setAviso(`Simulação criada! O convite foi para o e-mail do colega${r?.linkEntrevistador ? "; entre pelo botão “Entrar na sala”" : ""}.`); carregar();
      }} />}
      {remarcando && <ModalSimulacao remarcar={remarcando} fechar={() => setRemarcando(null)} criada={() => {
        setRemarcando(null); setAviso("Simulação remarcada! O colega recebeu o convite atualizado."); carregar();
      }} />}
      <div className="bg-white rounded-2xl shadow-sm p-5 text-sm">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <b className="text-text">🧪 Simular uma entrevista</b> <span className="ml-1 rounded-full bg-amber-100 text-amber-800 text-[11px] font-bold px-2 py-0.5">PILOTO</span>
            <p className="text-gray-600 mt-1">Teste a sala de entrevista com um colega, sem candidato real. Não conta na reputação da empresa.</p>
          </div>
          <button onClick={() => { setErro(""); setAviso(""); if (esgotou) setErro(`Sua empresa já usou as ${dados.limite} simulações desta semana${dados.liberaEm ? `; a próxima fica liberada em ${quando(dados.liberaEm)}` : ""}.`); else setModal(true); }}
            className="rounded-lg bg-accent hover:opacity-90 text-white font-semibold px-4 py-2">🧪 Simular uma entrevista</button>
        </div>
        {dados && <p className="text-xs text-gray-500 mt-2">{dados.usadas} de {dados.limite} simulações usadas nos últimos 7 dias.</p>}
      </div>
      {erro && <p className="mt-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
      {aviso && <p className="mt-3 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm px-3 py-2">{aviso}</p>}
      <div className="mt-4 space-y-3">
        {dados?.simulacoes?.map((s) => {
          const st = STATUS[s.status] || { txt: s.status, cls: "bg-slate-100" };
          return (
            <div key={s.id} className="bg-white rounded-2xl shadow-sm p-4 text-sm">
              <div className="flex flex-wrap items-center gap-2">
                <b className="text-text">Com {s.nomeColega}</b>
                <span className="text-gray-500">· {s.emailColega}</span>
                <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${st.cls}`}>{st.txt}</span>
              </div>
              <div className="text-gray-700 mt-1">{quando(s.inicio)} · {s.duracaoMin} min{s.remarcacoes > 0 && <span className="text-gray-500"> · remarcada {s.remarcacoes}x</span>}{s.whatsappColega && <span className="text-gray-500"> · WhatsApp {s.whatsappColega}</span>}</div>
              {s.status !== "agendada" && s.status !== "cancelada" && (
                <div className="text-xs text-gray-500 mt-1">
                  Feedback da IA — você: {FEEDBACK[s.feedbackEntrevistadorStatus] || s.feedbackEntrevistadorStatus} · colega: {FEEDBACK[s.feedbackColegaStatus] || s.feedbackColegaStatus}
                  {s.duracaoSeg != null && <> · {Math.max(1, Math.round(s.duracaoSeg / 60))} min de conversa</>}
                </div>
              )}
              <div className="flex flex-wrap gap-2 mt-3">
                {s.linkEntrevistador && <a href={s.linkEntrevistador} onClick={(ev) => abrirSala(ev, s.linkEntrevistador)} className="bg-brand text-white font-bold rounded-lg px-3 py-1.5 text-xs">Entrar na sala</a>}
                {s.linkColega && <button onClick={() => copiar(s.linkColega)} className="bg-slate-100 font-semibold rounded-lg px-3 py-1.5 text-xs" title="Para reenviar ao colega se o e-mail não chegar">Copiar link do colega</button>}
                {s.podeRemarcar && <button onClick={() => { setErro(""); setAviso(""); setRemarcando(s); }} className="bg-slate-100 font-semibold rounded-lg px-3 py-1.5 text-xs">Remarcar</button>}
                {s.podeCancelar && <button onClick={() => window.confirm("Cancelar esta simulação? O colega recebe um aviso. (Ela continua contando no limite da semana.)")
                  && cancelarSimulacao(s.id).then(() => { setAviso("Simulação cancelada."); carregar(); }).catch((e) => setErro(e.message))} className="text-red-600 text-xs font-semibold">Cancelar</button>}
              </div>
            </div>
          );
        })}
        {dados && dados.simulacoes?.length === 0 && <p className="text-sm text-gray-500">Nenhuma simulação ainda.</p>}
      </div>
    </div>
  );
}
